import React from 'react';
import {SvgIcon, SvgIconProps} from "@mui/material";

const SwapCallPutIconSvg = (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5 18C5 18 5 9.5 5 8.00002C5 6.50005 7 5 8.5 5C10 5 12 6.50005 12 8.00002C12 9.5 12 13.5 12 15C12 16.5 13.8432 18 15.5 18C17.1568 18 19 16.5 19 15C19 13.5 19 5 19 5M5 18L7.5 15.5M5 18L2.5 15.5M19 5L21.5 7.5M19 5L16.5 7.5"
            stroke="currentColor" strokeLinecap="round"/>
    </svg>


)
const SwapTradesIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {SwapCallPutIconSvg}
    </SvgIcon>
);
export default SwapTradesIcon
